import React from 'react'
import './PrivacyPolicy.scss'

const PrivacyPolicy = () => {
  return (
    <div className='privacy-policy-page full-width'>
      <div className='content main-grid'>
        <h1 className='unbounded-font'>Privacy Policy for bluecoast.com</h1>

        <h2>Effective Date: 10/10/2024</h2>

        <h3>Thank you for visiting the Blue Coast Studio website. Below, we outline our privacy policy to help you understand how we collect, use, process, and protect your personal information.</h3>

        <h4>Collection of Personal Information:</h4>
        <p>We collect personal information, such as name, email address, phone number, etc., which you voluntarily provide to us through contact forms, registration forms, or other forms on our website.</p>
        <h4>Purpose of Collecting Information:</h4>
        <p>Personal data is collected to respond to your inquiries, process orders, provide information about products and services, and for marketing purposes (if you provide consent).</p>
        <h4>Use of Cookies:</h4>
        <p>Our website may use cookies to track user activity. Cookies help us customize the content of the site to your preferences.</p>
        <h4>Protecting Your Data:</h4>
        <p>We are committed to protecting your personal data. We use appropriate security measures to safeguard your data from unauthorized access, loss, alteration, or destruction.</p>
        <h4>Sharing Personal Data:</h4>
        <p>We do not sell, trade, or share your personal data with third parties without your consent, except as required by law.</p>
        <h4>Your Rights:</h4>
        <p>You have the right to access, correct, delete, restrict processing, and port your personal data. You also have the right to withdraw consent for data processing at any time.</p>
        <h4>Contact:</h4>
        <p>For questions or concerns about our privacy policy, please contact us at: Virtual 3D Mauritius, Villa Royalle Unit 5, Grand Baie, Mauritius No BRN I21002726 Przemek Pietraszkiewicz Cell: +23058150447 Email: office@bluecoaststudio.mu</p>
        <h4>Changes to the Privacy Policy:</h4>
        <p>We reserve the right to make changes to our privacy policy. Any changes will be posted on this page.
        Please regularly check our privacy policy to stay informed about what information we collect and how we use it. By using our website, you agree to the terms of our privacy policy.</p>
      </div>
    </div>
  )
}

export default PrivacyPolicy